import { render, staticRenderFns } from "./DeleteArchiveModal.vue?vue&type=template&id=e865752c&lang=pug"
import script from "./DeleteArchiveModal.vue?vue&type=script&lang=js"
export * from "./DeleteArchiveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports